import { AxiosInstance } from "axios"

export class AutomationClient {
	constructor(private axiosClient: AxiosInstance) {}

	public sendOverdueAssessmentReminders = async (
		forceSendEmails: boolean
	) => {
		const params = new URLSearchParams()
		params.append("enableEmails", forceSendEmails.toString())
		await this.axiosClient.get(
			`/api/admin/automation/overdueemails?${params}`
		)
	}

	public generateAssessments = async (forceSendEmails: boolean) => {
		const params = new URLSearchParams()
		params.append("enableEmails", forceSendEmails.toString())
		await this.axiosClient.get(
			`/api/admin/automation/generateassessments?${params}`
		)
	}

	public sendInviteReminders = async (forceSendEmails: boolean) => {
		const params = new URLSearchParams()
		params.append("enableEmails", forceSendEmails.toString())
		await this.axiosClient.get(
			`/api/admin/automation/invitereminders?${params}`
		)
	}
}
